import * as yup from 'yup'

import { getMessage } from '../../util/IntlMessages'

export const CATEGORY_VALIDATION_SCHEMA = yup.object().shape({
  active: yup
    .boolean()
    .typeError('must be boolean')
    .required(getMessage('isRequired', getMessage('categoryActiveField'))),
  name: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('isRequired', getMessage('categoryNameField'))),
  proposito: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('isRequired', getMessage('categoryProposalField')))
})
